// extracted by mini-css-extract-plugin
module.exports = {"extraPaddingForGlobalNavbar":"Section_extraPaddingForGlobalNavbar__l180i"};